




















import { defineComponent, inject } from '@nuxtjs/composition-api';
import useSbCategories from '@shared/composables/useSbCategories';
import { ISearchCategoryFilter } from '@shared/types/search';
import { BaseList, BaseListItem, BaseLoader } from '@shared/ui';
import { getStoryblokImageURL } from '@unified-commerce/gpc-vue-storefront-storyblok';

import CategoryCardFlat from '~/components/CategoryCardFlat/CategoryCardFlat.vue';
import { CATEGORY_ROUTE_PREFIX } from '~/constants';

export default defineComponent({
  name: 'ShopAllCategories',
  components: {
    BaseList,
    BaseLoader,
    BaseListItem,
    CategoryCardFlat,
  },
  props: {
    title: {
      type: String,
      default: 'Shop all Categories',
    },
  },
  setup() {
    const topLevelCategories = inject('topLevelCategories');
    const { getSbCategoryById } = useSbCategories();

    const getSubCategoryImage = (subCategory: ISearchCategoryFilter) => {
      if (!subCategory) return;
      const categoryDefinition = getSbCategoryById(subCategory.id);
      const storyblokImageURL = categoryDefinition?.category?.thumb_image?.filename;
      if (storyblokImageURL) {
        return getStoryblokImageURL(storyblokImageURL, { width: 250 });
      }
    };

    return {
      topLevelCategories,
      getSubCategoryImage,
      CATEGORY_ROUTE_PREFIX,
    };
  },
});
